export const CODE_API_URL = '/contact/v1/code';
export const EVENT_INQUIRY_API_URL = '/contact/v1/inquiry/event';
export const ARENA_INQUIRY_API_URL = '/contact/v1/inquiry/arena';
export const UPLOAD_FILE_LIST_API_URL = '/contact/v1/file/upload';
export const DOWNLOAD_FILE_LIST_API_URL = '/contact/v1/file/download';
export const SEND_EMAIL_API_URL = '/contact/v1/mail/send';

// WEBSITE
export const FOOTER_ADDRESS_URL = '/api/v1/footer-wd-1?_format=json';
export const FOOTER_MENU_URL = '/api/v1/menu_custom_api?menu_name=footer';
export const FOOTER_CONTACT_URL = '/api/v1/footer-wd-3?_format=json';
export const FOOTER_SNS_URL = '/api/v1/footer-wd-4?_format=json';
export const PRIVACY_POLICY_URL = '/api/v1/about-us/privacy-policy';
export const TERMS_CONDITIONS_URL = '/api/v1/about-us/terms-conditions';

// CODE
export const ARENA_SELECTED = '1';
export const EVENT_SELECTED = '2';
